import React from 'react';
import TuiBreadCrumb, { IBreadCrumbData } from 'tradevan-ui/BreadCrumbs';

const BreadCrumb = (props: { data: IBreadCrumbData[] }) => {
  const { data } = props;
  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <h4 className="page-title"> </h4>
          <div className="page-title-left">
            <TuiBreadCrumb data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default BreadCrumb;
